import React, { useEffect, useState } from 'react';
import { inputStyle, labelStyle } from './surveillanceShared';

/**
 * Sifferfält som bara släpper igenom heltal.
 *
 * Fältet är av typen text, inte number. Ett sifferfält lämnar tillbaka tomt så
 * fort innehållet inte är ett färdigt tal, och då försvinner minustecknet innan
 * man hunnit skriva resten — obrukbart när nästan alla värden är minusgrader.
 * Vi låter i stället användaren skriva fritt och rundar av till heltal när fältet
 * lämnas eller Enter trycks. Komma funkar lika bra som punkt.
 */
const NumField: React.FC<{
    label: string;
    value: number;
    onChange: (n: number) => void;
    unit: string;
    disabled?: boolean;
}> = ({ label, value, onChange, unit, disabled }) => {
    const [draft, setDraft] = useState<string>(String(value));
    useEffect(() => { setDraft(String(value)); }, [value]);

    const commit = (raw: string) => {
        const n = Math.round(Number(raw.replace(',', '.').trim()));
        if (raw.trim() === '' || isNaN(n)) { setDraft(String(value)); return; }
        setDraft(String(n));
        if (n !== value) onChange(n);
    };

    return (
        <div style={{ minWidth: 130 }}>
            <label style={labelStyle}>{label}</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <input
                    type="text" inputMode="numeric" value={draft} style={inputStyle} disabled={disabled}
                    onChange={e => setDraft(e.target.value)}
                    onBlur={e => commit(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') commit((e.target as HTMLInputElement).value); }}
                />
                <span style={{ color: '#888', fontSize: 12 }}>{unit}</span>
            </div>
        </div>
    );
};

export default NumField;
